import { useEffect, useState } from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { api } from "@/lib/api";

const cache = {};

export function LuogoSelect({ value, onChange, kind = "", placeholder = "Cerca…", searchPlaceholder = "Digita il nome…", emptyText = "Nessun risultato", disabled, testId }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (!value) {
      setLabel("");
      return;
    }
    if (cache[value]) {
      setLabel(cache[value]);
      return;
    }
    api.get(`/lookup/luoghi/${value}`).then(({ data }) => {
      cache[value] = data.provincia ? `${data.name} (${data.provincia})` : data.name;
      setLabel(cache[value]);
    }).catch(() => setLabel(value));
  }, [value]);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      api.get("/lookup/luoghi", { params: { q, kind, limit: 25 } }).then(({ data }) => setItems(data)).catch(() => setItems([]));
    }, 200);
    return () => clearTimeout(t);
  }, [q, kind, open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testId}
          className="flex h-11 w-full items-center justify-between rounded-md border border-input bg-white px-3 text-left text-sm disabled:opacity-60">
          <span className={label ? "" : "text-stone-400"}>{label || placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 text-stone-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[260px]" align="start">
        <Command shouldFilter={false}>
          <CommandInput value={q} onValueChange={setQ} placeholder={searchPlaceholder} data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList>
            <CommandEmpty>{emptyText}</CommandEmpty>
            {items.map((it) => (
              <CommandItem key={it.code} value={it.code} data-testid={testId ? `${testId}-option-${it.code}` : undefined}
                onSelect={() => {
                  cache[it.code] = it.provincia ? `${it.name} (${it.provincia})` : it.name;
                  onChange(it.code, it);
                  setOpen(false);
                }}>
                <Check className={`mr-2 h-4 w-4 ${value === it.code ? "opacity-100" : "opacity-0"}`} />
                {it.name}{it.provincia ? ` (${it.provincia})` : ""}
                {!it.valid && <span className="ml-auto text-[10px] text-stone-400">non più attivo</span>}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
